import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions'; // Asegúrate de importar esto si estás usando Firebase
import { auth, functions } from '../../firebase';

import styles from './Home.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import mockupImage from '../../assets/images/iphone-mockup-completa.png'

const Home = () => {
  const { t } = useTranslation();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [emailError, setEmailError] = useState(false);

  const validateEmail = (email) => {
    // Expresión regular para validar el formato del email
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailPattern.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    // Validar el nuevo email
    if (validateEmail(newEmail)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };

  const isEmailValid = validateEmail(email);

  const sendContactMail = async () => {
    try {
      console.log("MANDANDO MAIL DE CONTACTO");

      const sendContactEmail = httpsCallable(functions, 'sendWelcomeEmail');

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Nuevo mensaje de contacto</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <style type="text/css">
                body { font-family: 'Lato', Helvetica, Arial, sans-serif; }
                .container { padding: 20px; background-color: #f4f4f4; }
                h1 { color: #394655; }
                p { color: #666666; }
            </style>
        </head>
        <body>
            <div class="container">
                <h1>Nuevo Mensaje de Contacto</h1>
                <p><strong>Email:</strong> ${email}</p>
                <p><strong>Mensaje:</strong></p>
                <p>${message}</p>
            </div>
        </body>
        </html>
      `;

      const result = await sendContactEmail({
        to: 'reveatpro@gmail.com', // Correo del equipo de soporte
        subject: `Nuevo mensaje de contacto de ${email}`,
        text: `Nuevo mensaje de contacto de ${email}. Mensaje: ${message}`,
        html: htmlContent
      });

      console.log('Email enviado:', result.data);

      // Mostrar toast de éxito
      toast.success('¡El correo se ha enviado correctamente!');

    } catch (error) {
      console.error('Error al enviar el email:', error);

      // Mostrar toast de error
      toast.error('Hubo un error al enviar el correo. Inténtalo nuevamente.');
    }
  };

  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <div className={styles.homeWrapper}>
      <div className={styles['is-boxed']} has-animations>
        <div className={`${styles['body-wrap']} ${styles['boxed-container']}`}>
          <main className='footer-margin'>
            {/* INIT */}
            <section className={styles['hero']}>
              <div className={styles['container']}>
                <div className={styles['hero-inner']}>
                  <div className={styles['hero-copy']}>
                    <h1 className={`${styles['hero-title']} ${styles['mt-0']}`}>{t('heroTitle')}</h1>
                    <p className={styles['hero-paragraph']}>{t('heroParagraph')}</p>
                    <div className={styles['hero-cta']}>
                      <a className={`${styles['button']} ${styles['button-shadow']}`} href="/faq">{t('heroCTA.moreInfo')}</a>
                      <a
                        className={`${styles['button']} ${styles['button-primary']} ${styles['button-shadow']}`}
                        href="/contact"
                      >
                        {t('heroCTA.contact')}
                      </a>
                    </div>
                  </div>
                  <div className={styles['hero-app']}>
                    <div className={styles['hero-app-illustration']}>
                      <svg width="999" height="931" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient x1="92.827%" y1="0%" x2="53.422%" y2="80.087%" id="hero-shape-a">
                            <stop stopColor="#FFA800" offset="0%" />
                            <stop stopColor="#F7DA89" stopOpacity="0" offset="100%" />
                          </linearGradient>
                          <linearGradient x1="92.827%" y1="0%" x2="53.406%" y2="80.12%" id="hero-shape-b">
                            <stop stopColor="#EFC94C" offset="0%" />
                            <stop stopColor="#FFA800" stopOpacity="0" offset="80.532%" />
                            <stop stopColor="#F7DA89" stopOpacity="0" offset="100%" />
                          </linearGradient>
                          <linearGradient x1="8.685%" y1="23.733%" x2="85.808%" y2="82.837%" id="hero-shape-c">
                            <stop stopColor="#F7DA89" stopOpacity=".48" offset="0%" />
                            <stop stopColor="#F7DA89" stopOpacity="0" offset="100%" />
                          </linearGradient>
                          <linearGradient x1="79.483%" y1="15.903%" x2="38.42%" y2="70.124%" id="hero-shape-d">
                            <stop stopColor="#EFC94C" offset="0%" />
                            <stop stopColor="#F7DA89" stopOpacity="0" offset="100%" />
                          </linearGradient>
                          <linearGradient x1="99.037%" y1="26.963%" x2="24.582%" y2="78.557%" id="hero-shape-e">
                            <stop stopColor="#F7DA89" stopOpacity=".64" offset="0%" />
                            <stop stopColor="#FFA800" stopOpacity=".24" offset="42.952%" />
                            <stop stopColor="#39372F" stopOpacity="0" offset="100%" />
                          </linearGradient>
                        </defs>
                        <g fill="none" fillRule="evenodd">
                          <g className="hero-shape-top">
                            <g className="is-moving-object is-translating" data-translating-factor="280">
                              <path d="M680.188 0c-23.36 69.79-58.473 98.3-105.34 85.531-70.301-19.152-189.723-21.734-252.399 91.442-62.676 113.175-144.097 167.832-215.195 118.57C59.855 262.702 24.104 287.85 0 370.988L306.184 566.41c207.164-4.242 305.67-51.612 295.52-142.11-10.152-90.497 34.533-163.55 134.054-219.16l4.512-119.609L680.188 0z" fill="url(#hero-shape-a)" transform="translate(1)" />
                            </g>
                            <g className="is-moving-object is-translating" data-translating-factor="100">
                              <path d="M817.188 222c-23.36 69.79-58.473 98.3-105.34 85.531-70.301-19.152-189.723-21.734-252.399 91.442-62.676 113.175-144.097 167.832-215.195 118.57-47.399-32.841-83.15-7.693-107.254 75.445L443.184 788.41c207.164-4.242 305.67-51.612 295.52-142.11-10.152-90.497 34.533-163.55 134.054-219.16l4.512-119.609L817.188 222z" fill="url(#hero-shape-b)" transform="rotate(-53 507.635 504.202)" />
                            </g>
                          </g>
                          <g transform="translate(191 416)">
                            <g className="is-moving-object is-translating" data-translating-factor="50">
                              <circle fill="url(#hero-shape-c)" cx="336" cy="190" r="190" />
                            </g>
                            <g className="is-moving-object is-translating" data-translating-factor="80">
                              <path d="M683.766 133.043c-112.048-90.805-184.688-76.302-217.92 43.508-33.23 119.81-125.471 124.8-276.722 14.972-3.156 120.356 53.893 200.09 171.149 238.202 117.256 38.112 250.937 6.355 401.043-95.268-41.026-63.083-77.674-120.124-109.947-171.123-20.488-33.478-40.152-25.884-58.603-30.291-18.451-4.407-31.979-8.714-48.974-30.185-17.469-22.014-36.717-29.06-60.026-29.06z" fill="url(#hero-shape-d)" />
                            </g>
                          </g>
                          <g transform="translate(191 416)">
                            <g className="is-moving-object is-translating" data-translating-factor="30">
                              <path d="M168.54 262.231c-101.204 0-146.583 39.684-136.136 119.053 6.022 44.96 51.078 80.796 136.136 107.5 85.06 26.704 188.038 1.418 308.935-75.853 120.896-77.27 202.96-155.235 246.093-233.894-157.055-26.63-288.843-51.33-395.365-74-48.825 102.836-109.704 157.194-182.636 163.973-23.05 1.972-50.098 1.972-77.027-6.779z" fill="url(#hero-shape-e)" />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <img className={styles["device-mockup"]} src={mockupImage} alt="App preview"></img>
                  </div>
                </div>
              </div>
            </section>

            {/* FEATURES */}
            <section className={styles.features + " " + styles.section}>
              <div className={styles.container}>
                <div className={`${styles.featuresInner} ${styles.sectionInner} ${styles.hasBottomDivider}`}>
                  <h2 className="sectionTitle">{t('sectionTitle')}</h2>
                  <div className={styles.featuresWrap}>
                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-2-b">
                                <stop stopColor="#EFC94C" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#F7DA89" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de tendencias con flechas y puntos de datos */}
                              <path d="M8,56 L56,56 L56,8" stroke="url(#feature-2-b)" strokeWidth="2" />
                              <path d="M14,44 L24,36 L36,40 L48,20" stroke="url(#feature-2-b)" strokeWidth="2" fill="none" />
                              <circle cx="24" cy="36" r="3" fill="url(#feature-2-b)" />
                              <circle cx="36" cy="40" r="3" fill="url(#feature-2-b)" />
                              <circle cx="48" cy="20" r="3" fill="url(#feature-2-b)" />
                              <path d="M48,20 L56,16 L52,24 Z" fill="url(#feature-2-b)" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.reviewAnalysis.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.reviewAnalysis.description')}
                        </p>
                      </div>
                    </div>

                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-1-a">
                                <stop stopColor="#FFA800" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#F7DA89" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de análisis con gráfico de barras y línea de tendencia */}
                              <path d="M8,48 L8,32 L18,32 L18,48 L8,48 Z M24,48 L24,16 L34,16 L34,48 L24,48 Z M40,48 L40,24 L50,24 L50,48 L40,48 Z" fill="url(#feature-1-a)" />
                              <path d="M4,52 L60,52" stroke="url(#feature-1-a)" strokeWidth="2" />
                              <path d="M12,40 C20,36 30,28 40,20 Q50,12 56,8" stroke="url(#feature-1-a)" strokeWidth="2" fill="none" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.interactiveCharts.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.interactiveCharts.description')}
                        </p>
                      </div>
                    </div>

                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-3-a">
                                <stop stopColor="#FFA800" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#EFC94C" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de reportes personalizados con documento y elementos gráficos */}
                              <path d="M12,8 L52,8 L52,56 L12,56 Z" stroke="url(#feature-3-a)" strokeWidth="2" fill="none" />
                              <path d="M20,20 L44,20 M20,32 L44,32 M20,44 L36,44" stroke="url(#feature-3-a)" strokeWidth="2" />
                              <path d="M16,4 L48,4 L48,12 L16,12 Z" fill="url(#feature-3-a)" />
                              <circle cx="44" cy="44" r="8" fill="url(#feature-3-a)" fillOpacity=".3" stroke="url(#feature-3-a)" strokeWidth="2" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.customReports.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.customReports.description')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="contact" className={styles.features + " " + styles.section}>
              <div className={styles.container}>
                <div className={`${styles.featuresInner} ${styles.sectionInner} ${styles.hasBottomDivider}`}>
                  <div className={styles.featuresWrap}>
                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-1-b">
                                <stop stopColor="#FFA800" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#F7DA89" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de comparativa de mercado con dos edificios/gráficas comparándose */}
                              <path d="M12,52 L12,32 L24,32 L24,52" stroke="url(#feature-1-b)" strokeWidth="2" fill="url(#feature-1-b)" fillOpacity="0.3" />
                              <path d="M28,52 L28,20 L40,20 L40,52" stroke="url(#feature-1-b)" strokeWidth="2" fill="url(#feature-1-b)" fillOpacity="0.3" />
                              <path d="M8,52 L56,52" stroke="url(#feature-1-b)" strokeWidth="2" />
                              {/* Flechas de comparación */}
                              <path d="M18,26 L34,26 M26,22 L34,26 L26,30" stroke="url(#feature-1-b)" strokeWidth="2" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.marketComparisons.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.marketComparisons.description')}
                        </p>
                      </div>
                    </div>

                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-2-b">
                                <stop stopColor="#EFC94C" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#F7DA89" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de lupa con gráfico de tendencia dentro */}
                              <circle cx="28" cy="28" r="16" stroke="url(#feature-2-b)" strokeWidth="2" />
                              <path d="M40,40 L52,52" stroke="url(#feature-2-b)" strokeWidth="3" />
                              {/* Línea de tendencia dentro de la lupa */}
                              <path d="M18,34 C22,30 26,32 32,24" stroke="url(#feature-2-b)" strokeWidth="2" />
                              <circle cx="24" cy="31" r="2" fill="url(#feature-2-b)" />
                              <circle cx="28" cy="28" r="2" fill="url(#feature-2-b)" />
                              <circle cx="32" cy="24" r="2" fill="url(#feature-2-b)" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.trends.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.trends.description')}
                        </p>
                      </div>
                    </div>

                    <div className={`${styles.feature} ${styles.isRevealing}`}>
                      <div className={styles.featureInner}>
                        <div className={styles.featureIcon}>
                          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="0%" y1="100%" x2="50%" y2="0%" id="feature-3-b">
                                <stop stopColor="#FFA800" stopOpacity=".8" offset="0%" />
                                <stop stopColor="#EFC94C" stopOpacity=".16" offset="100%" />
                              </linearGradient>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                              {/* Icono de proyecto vivo con elementos que sugieren crecimiento y movimiento */}
                              <path d="M32,8 C45.254,8 56,18.746 56,32 C56,45.254 45.254,56 32,56"
                                stroke="url(#feature-3-b)" strokeWidth="2" />
                              {/* Elementos de "vida" y crecimiento */}
                              <path d="M32,56 C18.746,56 8,45.254 8,32 C8,18.746 18.746,8 32,8"
                                stroke="url(#feature-3-b)" strokeWidth="2"
                                strokeDasharray="3,3" />
                              <circle cx="32" cy="8" r="3" fill="url(#feature-3-b)" />
                              <circle cx="32" cy="56" r="3" fill="url(#feature-3-b)" />
                              <path d="M22,32 L42,32 M32,22 L32,42"
                                stroke="url(#feature-3-b)" strokeWidth="2" />
                            </g>
                          </svg>
                        </div>
                        <h3 className={`${styles.featureTitle} ${styles.mt24}`}>{t('features.virtualAssistant.title')}</h3>
                        <p className={`${styles.textSm} ${styles.mb0}`}>
                          {t('features.virtualAssistant.description')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* CONTACT */}
            <section className={`${styles['newsletter']} ${styles['section']}`} style={{ paddingBottom: '3rem', textAlign: 'center' }}>
              <ToastContainer />
              <div className={styles['container-sm']} style={{ maxWidth: '600px', margin: '0 auto' }}>
                <div className={`${styles['newsletter-inner']} ${styles['section-inner']}`}>
                  <div className={styles['newsletter-header']}>
                    <h2 className={`${styles['section-title']} ${styles['mt-0']}`} style={{ fontSize: '2rem', marginBottom: '1.5rem' }}>{t('contact.title')}</h2>
                    <p className={styles['section-paragraph']} style={{ marginBottom: '1.5rem', fontSize: '1.1rem' }}>
                      {t('contact.paragraph')}
                    </p>
                  </div>
                  <div className={`${styles['footer-form']} ${styles['newsletter-form']} ${styles['field-grouped']}`}>
                    <div className={styles['control']} style={{ marginBottom: '1rem' }}>
                      <textarea
                        className={styles['input']}
                        name="message"
                        placeholder={t('contact.messagePlaceholder')}
                        style={{
                          width: '100%',
                          padding: '1rem',
                          borderRadius: '5px',
                          border: '1px solid #EFC94C',
                          fontSize: '1rem',
                          minHeight: '120px'
                        }}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                    <div className={styles['control']} style={{ marginBottom: '1rem' }}>
                      <input
                        className={styles['input']}
                        type="email"
                        name="email"
                        placeholder={t('contact.emailPlaceholder')}
                        style={{
                          width: '100%',
                          padding: '1rem',
                          borderRadius: '5px',
                          border: '1px solid #EFC94C',
                          fontSize: '1rem'
                        }}
                        value={email}
                        onChange={handleEmailChange}
                      />
                      {emailError && <div style={{ color: 'red', textAlign: 'left', marginLeft: 10, marginTop: 5 }}>{t("principalFormEmailInvalid")}</div>}
                    </div>
                    <div className={styles['control']}>
                      <button
                        className={`${styles['button']} ${styles['button-primary']} ${styles['button-shadow']}`}
                        style={{
                          padding: '1rem 2rem',
                          fontSize: '1rem',
                          width: '40%',
                          borderRadius: '5px',
                          cursor: isEmailValid ? 'pointer' : 'not-allowed'
                        }}
                        onClick={sendContactMail}
                        disabled={!isEmailValid}
                      >
                        {t('contact.sendButton')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Home;
